import { render, staticRenderFns } from "./CanalCobroShowData.vue?vue&type=template&id=3ec5759a"
import script from "./CanalCobroShowData.vue?vue&type=script&lang=js"
export * from "./CanalCobroShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports